import { Injectable } from '@angular/core';

import { OnDemandPublicTrip, RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ScheduleService } from '../../schedule.service';
import { OnDemandTripsActions } from './ondemand-trips.action';

@Injectable()
export class OnDemandTripsEpics implements RidangoEpic {
    constructor(
        private service: ScheduleService,
        private actions: OnDemandTripsActions,
    ) {}

    register() {
        return [this.fetchOnDemandTrips, this.fetchUpcomingTrips];
    }

    fetchOnDemandTrips = (action$: ActionsObservable<any>) =>
        action$.ofType(OnDemandTripsActions.FETCH_ONDEMAND_TRIPS).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchOnDemandPublicRoutes(action.payload).pipe(
                    map((response) => this.actions.fetchOnDemandTripsSuccess({ trips: response })),
                    catchError(() => of(this.actions.fetchOnDemandTripsFail()))
                );
            })
        )


    fetchUpcomingTrips = (action$: ActionsObservable<any>) =>
        action$.ofType(OnDemandTripsActions.FETCH_UPCOMING_TRIPS).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchUpcomingTrips().pipe(
                    map((d: OnDemandPublicTrip[]) => this.actions.fetchUpcomingTripsSuccess(d)),
                    catchError((e) => [this.actions.fetchUpcomingTripsFailed(e)])
                );
            })
        )
}
